var toInteger = require('../internals/to-integer');

module.exports = function (it) {
  var result = toInteger(it);
  if (result < 0) throw RangeError("The argument can't be less than 0");
  return result;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/to-positive-integer.js
// module id = 611
// module chunks = 0 1 5